<article class="container">
	<section class="modal-header">
		<p class="title">Cancelar reserva</p>
		<mat-icon
			svgIcon="pm-icons:close"
			style="width: 14px; height: 14px"
			(click)="closeModal()"
		></mat-icon>
	</section>

	<div class="modal-content">
		<p>Tem certeza que deseja cancelar a reserva?</p>
	</div>

	<section class="modal-footer">
		<button mat-raised-button (click)="closeModal()" style="width: 50%">Sair</button>
		@if (isLoading) {
			<ui-pm-loading-page style="--height: 50px" />
		} @else {
			<button mat-raised-button color="primary" (click)="cancelReservation()" style="width: 50%">
				Cancelar
			</button>
		}
	</section>
</article>
